module.exports = __webpack_public_path__ + "4e64ea42c3d10fdaba69ac91b1dcc8ff.svg";